import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { SiteFilter, StatusFilter, TestFilter, TimeRangeFilter, useTest } from '../../filters';
import { TestStatusPanel, TestDetailPanel } from '../../panels';
import PageActionsWithNg1DrillDown from '../../page-framework/page-header/PageActionsWithNg1DrillDown';

export const pageId = 'test-detail';

export default function TestDetailPage() {
    const test = useTest();
    const [isAdminUser] = useIsAdminUser();

    return (
        <Page id={pageId}>
            <PageHeader
                title={test?.name}
                titleActions={
                    test &&
                    !test.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link
                                to={`/admin/service-tests/${test?.typeNode?.group}/tests/${test?.uuid}`}
                                title={i18n._(t`Edit service test configuration`)}
                            >
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
                actions={<PageActionsWithNg1DrillDown pageTitle={test?.name} />}
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <TestFilter required />
                    <SiteFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <TestStatusPanel />
                <TestDetailPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
